<s1-input-label [label]="label">
    <textarea class="form-control col-12" [ngClass]="{'is-invalid' : !checkIsValid() }" [formControl]="control" 
        [readonly]="readonly" placeholder="{{ label | translate }}"
        [rows]="numRows"></textarea>
</s1-input-label>
